export const trimAndCompareLowerCase = (a, b) => {
    if (!a || !b)
        return false;
    return a.trim().toLowerCase() === b.trim().toLowerCase();
};
/**
 * Retrieves the current body type based on the selected model, year, and catalog data.
 *
 * @param currentSelectedModel - The name of the currently selected model.
 * @param currentSelectedYear - The year of the currently selected model.
 * @param catalog - The catalog object containing model and year data.
 * @returns The name of the body type if found, otherwise an empty string.
 */
const getCurrentBodyType = (currentSelectedModel, currentSelectedYear, catalog) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (!currentSelectedModel || !currentSelectedYear || !catalog)
        return '';
    const [models] = (_b = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.fields) === null || _a === void 0 ? void 0 : _a.models) !== null && _b !== void 0 ? _b : [];
    const modelItem = (_c = models === null || models === void 0 ? void 0 : models.items) === null || _c === void 0 ? void 0 : _c.find(item => {
        var _a;
        return trimAndCompareLowerCase(item === null || item === void 0 ? void 0 : item.name, currentSelectedModel) ||
            trimAndCompareLowerCase((_a = item === null || item === void 0 ? void 0 : item.modelName) === null || _a === void 0 ? void 0 : _a.value, currentSelectedModel);
    });
    if (modelItem) {
        const modelYearItem = (_d = modelItem === null || modelItem === void 0 ? void 0 : modelItem.modelYears) === null || _d === void 0 ? void 0 : _d.find(modelYear => { var _a; return ((_a = modelYear === null || modelYear === void 0 ? void 0 : modelYear.year) === null || _a === void 0 ? void 0 : _a.value) === currentSelectedYear; });
        if (modelYearItem) {
            return ((_k = (_j = (_h = (_g = (_f = (_e = modelYearItem.defaultTrim) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.trimFilters) === null || _g === void 0 ? void 0 : _g.items) === null || _h === void 0 ? void 0 : _h.find(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.filterCategory) === null || _a === void 0 ? void 0 : _a.name) === 'bodyType'; })) === null || _j === void 0 ? void 0 : _j.name) !== null && _k !== void 0 ? _k : '');
        }
    }
    return '';
};
export default getCurrentBodyType;
